/**
 * Artemis Application Server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * API Version: 9.7
 * Contact: krusche@tum.de
 *
 * NOTE: This file is auto-generated. Do not edit manually.
 */

import type { EntityIdRef } from './entity-id-ref';
import type { ShortAnswerSubmittedTextFromLiveClient } from './short-answer-submitted-text-from-live-client';

export interface ShortAnswerSubmittedAnswerFromLiveClient {
    quizQuestion?: EntityIdRef;
    submittedTexts?: Array<ShortAnswerSubmittedTextFromLiveClient>;
    type: ShortAnswerSubmittedAnswerFromLiveClientTypeEnum;
}

export type ShortAnswerSubmittedAnswerFromLiveClientTypeEnum = 'short-answer';

export const ShortAnswerSubmittedAnswerFromLiveClientTypeEnum = {
    ShortAnswer: 'short-answer' as const,
} as const;

export const ShortAnswerSubmittedAnswerFromLiveClientTypeEnumValues = ['short-answer'] as const;

